export const useIsZeusJob = (defaultGuideVersion: number | undefined) =>
  (defaultGuideVersion ?? 1) >= 2;

export const useShowLegacySettingsForGuide = (
  jobDefaultGuideVersion: number | undefined,
  guideVersion: number | undefined
) => {
  const jobIsZeus = useIsZeusJob(jobDefaultGuideVersion);
  return jobIsZeus && guideVersion === 1;
};
